var map = {
	"./2dmap/changeMap2D.png": "1ruG",
	"./2dmap_eyes/changeMap2D.png": "/yrS"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "YSpY";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/.*\/changeMap2D\.png$
// module id = YSpY
// module chunks = 2